import posthog from "posthog-js";

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST;
const localHostnames = new Set(["localhost", "127.0.0.1", "0.0.0.0"]);

let initialized = false;

const isLocalEnvironment = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return localHostnames.has(window.location.hostname);
};

export const initPostHog = () => {
  if (
    initialized ||
    !posthogKey ||
    !posthogHost ||
    typeof window === "undefined" ||
    isLocalEnvironment()
  ) {
    return posthog;
  }

  posthog.init(posthogKey, {
    api_host: posthogHost,
    autocapture: true,
    capture_pageview: false,
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "[data-posthog-mask]",
    },
  });

  initialized = true;
  return posthog;
};

export const isPostHogEnabled = () => {
  return Boolean(posthogKey && posthogHost) && !isLocalEnvironment();
};

export const captureEvent = (eventName, properties) => {
  if (!initialized) {
    return;
  }

  posthog.capture(eventName, properties);
};

export const identifyPostHogUser = (user) => {
  if (!initialized || !user?.uid) {
    return;
  }

  posthog.identify(user.uid, {
    email: user.email,
    name: user.displayName,
    organization_id: user.subscription?.organization_id,
    plan: user.subscription?.plan,
    role: user.subscription?.role,
    department: user.subscription?.department,
  });
};

export const resetPostHogUser = () => {
  if (!initialized) {
    return;
  }

  posthog.reset();
};

export { posthog };
